import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TextThirdPartyInfoComponent } from './text-third-party-info.component';

@NgModule({
  declarations: [TextThirdPartyInfoComponent],
  imports: [
    CommonModule,
    FormsModule, ReactiveFormsModule,
  ],
  exports:[TextThirdPartyInfoComponent],
})
export class TextThirdPartyInfoModule { }
